module.exports = {"type":"object","required":["name","version"],"properties":{"name":{"type":"string"},"version":{"type":"string"},"comment":{"type":"string"}}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/har-validator/lib/schemas/creator.json
// module id = 4t2O
// module chunks = 14